var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon48BlogWine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54 6.43c4.61-.76 5.59 1.14 9.18 1.12",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.22 23H6.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.02 2v1.13c0 3.84-1.18 7.6-3.37 10.75l-.14.2-.14-.2A18.84 18.84 0 0 1 8 3.13V2h7.02m0-2H8a2 2 0 0 0-2 2v1.13c0 4.27 1.29 8.38 3.73 11.89l.14.2a2 2 0 0 0 3.28 0l.14-.2a20.72 20.72 0 0 0 3.73-11.88V2a2 2 0 0 0-2-2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.51 15.44V23"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0iTTYuNTQgNi40M2M0LjYxLS43NiA1LjU5IDEuMTQgOS4xOCAxLjEyIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIvPg0KICAgIDxwYXRoIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik0xNi4yMiAyM0g2LjgiLz4NCiAgICA8cGF0aCBkPSJNMTUuMDIgMnYxLjEzYzAgMy44NC0xLjE4IDcuNi0zLjM3IDEwLjc1bC0uMTQuMi0uMTQtLjJBMTguODQgMTguODQgMCAwIDEgOCAzLjEzVjJoNy4wMm0wLTJIOGEyIDIgMCAwIDAtMiAydjEuMTNjMCA0LjI3IDEuMjkgOC4zOCAzLjczIDExLjg5bC4xNC4yYTIgMiAwIDAgMCAzLjI4IDBsLjE0LS4yYTIwLjcyIDIwLjcyIDAgMCAwIDMuNzMtMTEuODhWMmEyIDIgMCAwIDAtMi0yeiIgZmlsbD0iIzAwMCIgLz4NCiAgICA8cGF0aCBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNMTEuNTEgMTUuNDRWMjMiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { SvgIcon48BlogWine as ReactComponent };